import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { PackagePartItem } from "../../../queries/useSearchPartPackagesByVehicle";
import { Dialog } from "../../../ui/Dialog/Dialog";
import { DialogHeader } from "../../../ui/Dialog/DialogHeader";
import { getPartName } from "../../../util/getPartName";
import { Footer } from "./Footer";

export const CopyPackageDialog: FunctionComponent<{
  onClose: VoidFunction;
  packageToCopy?: PackagePartItem;
}> = ({ onClose, packageToCopy }) => {
  const { t } = useTranslation();
  const [language] = useLanguage();

  return (
    <Dialog
      className="xl:max-w-md"
      id="package-copy-dialog"
      onClose={onClose}
      placement="top"
      visible={!!packageToCopy}
    >
      <DialogHeader onClose={onClose} title={t("packageEditor.copyPackage")} />
      <div className="p-4">
        {t("packageEditor.packageCopyNote", {
          packageName: getPartName(packageToCopy, language),
        })}
      </div>
      <Footer hide={onClose} packageToCopy={packageToCopy} />
    </Dialog>
  );
};
